import { baseApi } from '../axios';

export const getResource = async ({ resourceId }: { resourceId?: string }) => {
	const response = await baseApi.get(`/resource/${resourceId}`);
	return response;
};
